import { gql } from "@apollo/client";

export const GET_SLA_RULES = gql`
  query getSLARules {
    sla_preferences {
      edges {
        node {
          id
          name
          user {
            first_name
            last_name
            email
          }
          selection_rule {
            filter {
              id
              name
              filter_data
            }
            scopesid
            scope_group
          }
          time_to_respond
          enabled
          is_system
        }
      }
    }
  }
`;
